// utils/utm.js
export function captureUTMParams() {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = [
      "utm_id",
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
    ];
    const utmData = {};
    utmParams.forEach((param) => {
      const value = urlParams.get(param);
      if (value) {
        localStorage.setItem(param, value);
        utmData[param] = value;
      }
    });
    return utmData;
  }
  return {};
}
